import { render, staticRenderFns } from "./btn-home.vue?vue&type=template&id=889a77dc"
import script from "./btn-home.vue?vue&type=script&lang=js"
export * from "./btn-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports